module.exports = __webpack_public_path__ + "static/media/apple.13b72f8e.svg";